import {inlineError} from '@s-ui/decorators/lib/index.js'
import {UseCase} from '@s-ui/domain'

import {TradeEntity} from '../Entities/TradeEntity.js'
import {HTTPTransactionRepository} from '../Repositories/HTTPTransactionRepository.js'

/**
 * @implements UseCase
 */
class RejectTradeSellerTransactionsUseCase extends UseCase {
  #repository

  static create({config}) {
    return new RejectTradeSellerTransactionsUseCase({repository: HTTPTransactionRepository.create({config})})
  }

  constructor({repository}) {
    super()
    this.#repository = repository
  }

  @inlineError
  async execute({tradeId}) {
    const tradeEntity = TradeEntity.create({id: tradeId})

    const [error] = await this.#repository.rejectTradeSeller({tradeEntity})

    if (error) throw error
  }
}

export default RejectTradeSellerTransactionsUseCase.create
